var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupedArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 32,
    viewBox: "0 0 83 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M19.2 6.4v-6.4l6.4 3.2-6.4 3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M32 6.4v-6.4l6.4 3.2-6.4 3.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M0 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M12.8 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M25.6 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d282be",
    stroke: "#d282be",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.2941,
    d: "M38.4 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M51.2 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M64 19.2v-6.4l5.867 3.198-5.867 3.202z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M76.267 19.2v-6.4l6.4 3.198-6.4 3.202z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M51.2 32v-6.4l6.4 3.2-6.4 3.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M64 32v-6.4l6.4 3.2-6.4 3.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0082",
    d: "M76.267 32v-6.4l6.4 3.2-6.4 3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedArrows);
export default __webpack_public_path__ + "static/media/grouped-arrows.1bd43281244df66a4bee7677b7193e11.svg";
export { ForwardRef as ReactComponent };